import { FvDate, Icon } from '@fv/client-components'
import type {
  EstimatedDeliveryTimeWindow,
  FullShipment,
} from '@fv/client-types'

import { formatTrackingDateTime } from '@/features/track/utils'
import { getDestination } from '@/utils/shipmentFuncs'

import { ShipperTooltip } from '../ShipperTooltip'

const buildTimeString = (timeWindow?: EstimatedDeliveryTimeWindow) => {
  const begins = timeWindow?.begins
    ? formatTrackingDateTime(timeWindow.begins, { dateFormat: '' }) // hide date
    : undefined
  const ends = timeWindow?.ends
    ? formatTrackingDateTime(timeWindow.ends, { dateFormat: '' })
    : undefined

  if (begins && ends) {
    return `between ${begins} and ${ends}`
  }
  if (begins) {
    return `after ${begins}`
  }
  if (ends) {
    return `by ${ends}`
  }
  return undefined
}

type Props = {
  load: FullShipment
}
export const DeliveryDate = ({ load }: Props) => {
  const { locations } = load
  const destination = getDestination({ locations })
  let deliveryText = <span>No delivery date specified</span>
  if (destination?.stopDate) {
    deliveryText = (
      <span>
        Requested delivery{' - '}
        <FvDate val={destination.stopDate} format="ddd MMM D, YYYY" />
      </span>
    )
  }
  if (!destination?.stopDate && load.estimatedDeliveryDate) {
    const trackingTimeWindow = buildTimeString(
      load.tracking?.estimatedDeliveryTimeWindow,
    )
    deliveryText = (
      <span>
        ETA <FvDate val={load.estimatedDeliveryDate} format="ddd MMM D, YYYY" />{' '}
        {trackingTimeWindow}
      </span>
    )
  }

  return (
    <ShipperTooltip label={deliveryText}>
      <span className="truncate">
        <Icon icon="calendar-day" className="text-fv-gray-dark" />
        {deliveryText}
      </span>
    </ShipperTooltip>
  )
}
